export function loadDaumPostcode() {
    return new Promise((resolve, reject) => {
        if (typeof window === "undefined") return reject(new Error("SSR"));
        if (window.daum?.Postcode) return resolve(window.daum.Postcode);

        const id = "daum-postcode-script";
        const exist = document.getElementById(id);
        if (!exist) {
            const s = document.createElement("script");
            s.id = id;
            s.src = "https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";
            s.async = true;
            s.onload = () => resolve(window.daum?.Postcode);
            s.onerror = () => reject(new Error("script load error"));
            document.head.appendChild(s);
        } else {
            const check = setInterval(() => {
                if (window.daum?.Postcode) {
                    clearInterval(check);
                    resolve(window.daum.Postcode);
                }
            }, 50);
            setTimeout(() => { clearInterval(check); reject(new Error("load timeout")); }, 5000);
        }
    });
}
